import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=385a06cb&scoped=true"
import script from "./CommonSection.vue?vue&type=script&lang=ts"
export * from "./CommonSection.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=385a06cb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a06cb",
  null
  
)

export default component.exports